export default __webpack_public_path__ + "static/qt-sweetcombe-marque-4-star-gold-rgb-05a0fa547f37bef04b7d711af556db52.png";